import React, { useEffect, useState } from 'react'
import {
  CrudFilters,
  getDefaultFilter,
  IResourceComponentsProps,
} from '@refinedev/core'
import { DateField, List, useTable } from '@refinedev/antd'
import '../styles/index.css'
import { ColumnType } from 'antd/es/table'
import { Row } from '../components/interface'
import { TableForm } from '../crypto-withdrawal/tableForm'
import { Badge, Button, Table } from 'antd'
import {
  CalendarOutlined,
  DollarOutlined,
  SyncOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { formatDate } from '../components/constants'
import {
  paymentStatusColors,
  paymentStatusNames,
} from '../../utils/paymentStatus.utils'
import { getUserWallet } from '../../utils/blockchain'
import { handleConnect } from '../../api/wallet'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

export const TransactionsHistory: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps, filters } = useTable<Row>({
    syncWithLocation: true,
    pagination: {
      pageSize: 10,
    },
    onSearch: (data: unknown) => {
      const params = data as { searchValue: string; createdAt: string[] }
      const filters: CrudFilters = []
      const { searchValue, createdAt } = params
      filters.push(
        {
          field: '',
          operator: 'contains',
          value: searchValue,
        },
        {
          field: '',
          operator: 'gte',
          value: createdAt
            ? dayjs(createdAt[0]).startOf('D').toISOString()
            : undefined,
        },
        {
          field: '',
          operator: 'lte',
          value: createdAt
            ? dayjs(createdAt[1]).endOf('D').toISOString()
            : undefined,
        }
      )

      return filters
    },
  })
  const [userWallet, setUserWallet] = useState<string | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      try {
        const result = await getUserWallet()
        if (result.status === 200) {
          setUserWallet(result.data.wallet)
        }
      } catch {
        setUserWallet(null)
      }
    })()
  }, [])

  function getHeaderButton() {
    if (!userWallet) {
      return (
        <Button
          type='primary'
          style={{ borderRadius: 0 }}
          onClick={async () => {
            const wallet = await handleConnect()
            setUserWallet(wallet)
          }}>
          Connect wallet
        </Button>
      )
    }

    return (
      <Button style={{ borderRadius: 0 }} onClick={() => navigate('/wallet')}>
        Manage wallet
      </Button>
    )
  }

  const columns: ColumnType<Row>[] = [
    {
      dataIndex: 'id',
      title: <span className={'column-header'}>&nbsp;№ ID</span>,
    },
    {
      dataIndex: 'customer',
      title: (
        <span className={'column-header'}>
          <UserOutlined />
          &nbsp;Customer
        </span>
      ),
    },
    {
      dataIndex: 'serviceProvider',
      title: 'Service provider',
    },
    {
      dataIndex: 'amount',
      title: (
        <span className={'column-header'}>
          <DollarOutlined />
          &nbsp;Amount
        </span>
      ),
    },
    {
      dataIndex: 'currencyCode',
      title: (
        <span className={'column-header'}>
          <DollarOutlined />
          &nbsp;Currency
        </span>
      ),
    },
    {
      dataIndex: 'createdAt',
      title: (
        <span className={'column-header'}>
          <CalendarOutlined />
          &nbsp;Date
        </span>
      ),
      render: (value: string) => (
        <DateField value={value} format={formatDate} />
      ),
    },
    {
      dataIndex: 'status',
      title: (
        <span className={'column-header'}>
          <SyncOutlined />
          &nbsp;Status
        </span>
      ),
      render: (value: string) => (
        <Badge
          color={paymentStatusColors[value]}
          text={paymentStatusNames[value]}
        />
      ),
    },
  ]

  return (
    <>
      <List title='Transactions History' headerButtons={getHeaderButton()}>
        <TableForm
          {...searchFormProps}
          initialValues={{
            searchValue: getDefaultFilter('', filters),
          }}
          onSubmit={searchFormProps.form?.submit}
          searchPlaceholder='Search by company name'
          showDateFilter={true}
        />
        <Table
          {...tableProps}
          rowKey='id'
          columns={columns as any}
          dataSource={tableProps.dataSource}
        />
      </List>
    </>
  )
}
